import { LayoutLoading } from 'components/LayoutLoading'
import { useEffect, useMemo, useState } from 'react'
import { getAdminConfig } from 'services'
import { PlainTable } from 'stories/components'

export interface IHMDAMapType {
  entity: 'Loan' | 'Borrower'
  field: string
  fieldTitle: string
  map?: Record<string, any> | string[]
}

export const HMDAConfiguration = () => {
  const [isLoading, setLoading] = useState(true)
  const [link, setLink] = useState('')
  const [data, setData] = useState<Record<string, IHMDAMapType>>({})

  useEffect(() => {
    getAdminConfig('hmda')
      .then(({ link, config }) => {
        setLink(link)
        setData(config)
      })
      .finally(() => setLoading(false))
  }, [])

  const renderMapTable = (data: Record<string, any> | string[]) => {
    return (
      <div>
        <table>
          {Array.isArray(data)
            ? data.map((val) => (
                <tr>
                  <td className="border-b">{val}</td>
                </tr>
              ))
            : Object.keys(data).map((key) => (
                <tr>
                  <td className="border-b pr-2 border-r">{key}</td>
                  <td className="border-b pl-2">{data[key]}</td>
                </tr>
              ))}
        </table>
      </div>
    )
  }

  const tableData = useMemo(() => {
    return Object.keys(data).map((key, index) => {
      const { entity, fieldTitle, map } = data[key]
      return [
        index + 1,
        <a target="_blank" className="btn-link" href={`${link}#${key}`}>
          {key}
        </a>,
        `${entity} => ${fieldTitle}`,
        !map ? '=' : renderMapTable(map),
      ]
    })
  }, [data])

  return (
    <div>
      <LayoutLoading show={isLoading} />
      <PlainTable
        thClass="!px-4"
        tdClass="px-4 py-2 whitespace-nowrap"
        header={['No', 'CFPB field', 'Field', 'Data Mapping']}
        data={tableData}
      />
    </div>
  )
}
